import { Inject, Injectable, Injector } from '@angular/core';

import { Utilities_ReportService } from './Utilities.report.index';
import { IntraOne_ReportService } from './IntraOne.report.index';


@Injectable({ providedIn: 'root' })
export class app_ReportService {

  constructor(
    private injector: Injector
  ) {
    this.Utilities = this.injector.get(Utilities_ReportService);
    this.IntraOne = this.injector.get(IntraOne_ReportService);
  }
    public Utilities: Utilities_ReportService;
    public IntraOne: IntraOne_ReportService;

  public app: app_ReportService = this;

  // injecting lazily in order to avoid circular dependencies
}

